import {MetaData} from "@qid/core";


export class Industry extends MetaData {
    name: string;
    parentIndustry: string;
    _id: any;
}
